import React, { useState } from "react";
import { ServiceStyle } from "./ServiceStyle";
import { Box, Typography } from "@mui/material";
import ServiceToggle from "./ServiceToggle";
import EcheckVideoPlayer from "../../../utils/videoPlayer";

const ServicePopup = (props) => {
  const { data, ServiceName } = props;

  const [animateIn, setAnimateIn] = useState(false);
  const [language, setLanguage] = useState("english");
  const [text, setText] = useState(false);

  const selectedUrl =
    language === "english"
      ? data?.ai_url?.english_url
      : data?.ai_url?.spanish_url;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          p: 2,
          minHeight: "80vh",
        }}
      >
        {data?.service_text ? (
          <Box sx={ServiceStyle.poppuMainBox}>
            <Box sx={ServiceStyle.toggleBox}>
              <ServiceToggle
                language={language}
                setLanguage={setLanguage}
                text={text}
                setText={setText}
              />
            </Box>
            {!text ? (
              <Box sx={ServiceStyle.videoBox}>
                <Box
                  sx={{
                    zIndex: 0,
                    width: "100%",
                    height: { xs: "70vh", sm: "70vh" },
                    minHeight: "420px",
                    maxWidth: { xs: "100%", sm: "70%", md: "720px" },
                    mx: "auto",
                  }}
                >
                  {selectedUrl ? (
                    <EcheckVideoPlayer
                      key={selectedUrl}
                      src={selectedUrl}
                      animateIn={animateIn}
                      onReady={() => {
                        setAnimateIn(true);
                      }}
                      autoPlay
                    />
                  ) : null}
                </Box>
              </Box>
            ) : (
              <Box sx={ServiceStyle.textBox}>
                <Box sx={ServiceStyle.insideText}>
                  <Typography variant="h6">{ServiceName}:</Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: window.innerWidth <= 750 ? 20 : 15 }}
                  >
                    {language === "english"
                      ? data?.service_text
                      : data.es_service_text}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              p: 5,
            }}
          >
            <Typography variant="h6" sx={{ textAlign: "center", mt: 2 }}>
              {ServiceName} is not available at the moment.
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default ServicePopup;
